import { type ReactElement, useEffect } from 'react';

type DocumentTitleProps = {
  title: string;
  suffix?: false | string;
};

export function DocumentTitle({
  title,
  suffix = 'DP',
}: DocumentTitleProps): ReactElement {
  const documentTitle = suffix ? `${title} - ${suffix}` : title;

  useEffect(() => {
    document.title = documentTitle;
  }, [documentTitle]);

  return <title>{documentTitle}</title>;
}
